import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { webApiHeaders } from "../../apiConfig";
import { ProfileContext } from "../../context/ContextProfile";

import ProfileShell from "./ProfileShell";
import Header from "../../components/profile/Header";
import Footer from "../../components/profile/Footer";
import Gallery from "../../components/profile/gallery/Gallery";
import Silbina from "../../components/profile/Silbina";

// Route: /:code  →  aldealista.com/<village> (the printed QR target).
// Resolves the code against the API and renders that village's profile.
export default function VillageProfile() {
  const { code } = useParams();
  const navigate = useNavigate();
  const { modifyVillage } = useContext(ProfileContext);

  const [isMegaMatch, setIsMegaMatch] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // Legacy static page, kept on the marketing host.
    if (code === "mapadeseorural") {
      window.location.replace("https://aldealista.com/mapadeseorural.html");
      return;
    }

    let active = true;
    setReady(false);

    axios({
      method: "post",
      url: "https://services.aldealista.com/v1/web/village-info",
      headers: webApiHeaders,
      params: {
        code,
        isScan: 1,
      },
    })
      .then((res) => {
        if (!active) return;
        const found = res.data.errorCode === 0;

        if (found) modifyVillage(res.data);

        // "silbina" always renders the megamatch variant, even without data.
        if (code === "silbina") {
          setIsMegaMatch(true);
          setReady(true);
        } else if (found) {
          setReady(true);
        } else {
          navigate("/", { replace: true });
        }
      })
      .catch(() => {
        if (active) navigate("/", { replace: true });
      });

    return () => {
      active = false;
    };
  }, [code]);

  if (!ready) return null;

  return (
    <ProfileShell>
      {isMegaMatch ? (
        <>
          <Silbina />
          <Footer />
        </>
      ) : (
        <>
          <Header />
          <Gallery />
          <Footer />
        </>
      )}
    </ProfileShell>
  );
}
